import { Grid, Typography } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { Applicant } from '../../redux-store/types/api-types';
import { grossAnnualMasters, investorTypeMasters, PEPsMasters } from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  currencyConversion,
  getUniqueIdentityText,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions/mdms';
import dayjs from 'dayjs';
import { CountryCodesDropDown } from '../commonComponents';

const contributorObject: Partial<Applicant> = {
  name: '',
  countryOfIncorporation: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  amlCheck: undefined,
  kraVerified: '',
  kraMobileNumber: '',
  kraEmailId: '',
  grossAnnualIncome: '',
  netWorth: '',
  netWorthDate: '',
  politicallyExposedPersonStatus: '',
  gstRegNo: '',
  cin: ''
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<Applicant>[];
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
};

type mdmsCountriesList = {
  name: string;
  dial_code: string;
  code: string;
  nationality: string;
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { locale } = useSelector((store: RootStateType) => store.currencyInfo);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);


  useEffect(() => {
    (async function () {
      try {
        const { applicants = [] } = application || {};
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setContributorValues({
          ...contributorValues,
          applicants: applicants.length ? applicants : [contributorObject],
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType, applicants = [] } = values;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
            application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
              ...bank,
              pennydropCheck: false,
              pennydropVerified: false,
            })),
        applicants: values.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );

    if (id && !checkApplication) {
      return await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
                application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                  ...bank,
                  pennydropCheck: false,
                  pennydropVerified: false,
                })),
            applicants: values.applicants.map((applicant) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
            })),
            modeOfHolding: 'single',
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    }
    return true;
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      const res = await handleApplicant(values)
      if (!res) return;
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, NonIndividualContributorValidationSchema(locale), true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/* <DatePicker
                      label={'Date of Registration/Incorporation *'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'DD/MM/YYYY'}
                      name={`applicants.${index}.dateOfBirth`}
                      disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    /> */}
                  <TextDatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'Enter Net worth as on Date'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.ckycNo`}
                      label="CKYC No./CKYC Acknowledge No./KIN No "
                      placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                    />
                  </Grid> */}
                <Grid item xs={12} sm={6}>
                  <SearchableSelect
                    name={`applicants.${index}.countryOfIncorporation`}
                    label="Country of registration/Incorporation *"
                    placeholder="Enter Country of Registration/Incorporation"
                    items={mdmsCountriesList.map((nationality) => ({
                      key: nationality.name,
                      value: nationality.name,
                    }))}
                    searchFieldPlaceholder={'Search Country'}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(investorTypeMasters).map((investor) => ({
                      key: investorTypeMasters[investor],
                      value: investor,
                    }))}
                    dropdownOptionStyle={{ whiteSpace: 'break-spaces' }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label={`${getUniqueIdentityText(company)?.pan} *`}
                    placeholder={`Enter ${getUniqueIdentityText(company)?.pan}`}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.kraVerified`}
                    label="CVL KRA Verified"
                    placeholder="CVL KRA Verified"
                    disabled={true}
                    value={applicant?.kraVerified?.toLowerCase() === "yes" ? "Yes" : "No"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.amlCheck`}
                    label="AML Verified"
                    placeholder="AML Verified"
                    disabled={true}
                    value={applicant?.amlCheck ? "Yes" : "No"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.kraMobileNumber`}
                    label="KRA Mobile Number"
                    placeholder="KRA Mobile Number"
                    disabled={false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.kraEmailId`}
                    label="KRA Email Id"
                    placeholder="KRA Email Id"
                    disabled={false}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.gstRegNo`}
                    label={`TIN/GST Registration No`}
                    placeholder={`Enter TIN/GST Registration No.`}
                    disabled={false}
                  />
                </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cin`}
                    label={`Company Identification No.`}
                    placeholder={`Company Identification No.`}
                    disabled={false}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    label="Mobile Number"
                    name={`applicants.${index}.mobile`}
                    placeholder=""
                    disabled
                    value={`${applicant?.mobile ?? ""}`}
                    startAdornment={
                      <CountryCodesDropDown
                        name={`applicants.${index}.countryNameAndCode`}
                        value={`${applicant?.countryNameAndCode ?? ""}`}
                        disabled
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    label="Email ID"
                    name={`applicants.${index}.email`}
                    placeholder=""
                    disabled
                    value={`${applicant?.email ?? ""}`}
                  />
                </Grid>
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income *"
                    items={grossAnnualMasters(locale).map(({ key, value }) => ({
                      key,
                      value
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status"
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                  // disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="Net Worth *"
                    placeholder="Enter Net Worth"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(locale, values.applicants[index].netWorth)}
                      </Typography>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextDatePicker
                    label={'Net Worth as on Date *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    maxDate={dayjs().subtract(1, 'day').toDate()}
                    placeholder={'Enter Net worth as on'}
                    name={`applicants.${index}.netWorthDate`}
                  />
                </Grid>
              </React.Fragment>
            ))}
            <Grid item xs={12} my={2} />
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
